module.exports = __webpack_public_path__ + "img/custom1.c1869ab9.png";